export const formatAmount = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "";

  const absAmount = Math.abs(amount);
  if (absAmount >= 1_000_000_000) {
    return (amount / 1_000_000_000).toFixed(1).replace(/\.0$/, "") + "B";
  } else if (absAmount >= 1_000_000) {
    return (amount / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (absAmount >= 1_000) {
    return (amount / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  }

  return Math.floor(amount).toString();
};

export const getRandomColor = () => {
  const colors = [
    "#f56a00", // Orange
    "#1890ff", // Blue
    "#52c41a", // Green
    "#13c2c2", // Teal
    "#eb2f96", // Pink
    "#ff7a45", // Red
    "#ffc107", // Yellow
    "#a0d911", // Lime
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

export const getDocType = (key) => {
  switch (key) {
    case "EPROCEEDING":
      return "E Proceeding";
    case "RESPONSEOUTSTANDING":
      return "Response to Outstanding Demand";
    case "GSTNOTICE":
      return "GST Notice And Order";
    case "GSTADDNOTICE":
      return "GST Additional Notice And Order";
    case "TDSNOTICE":
      return "Quarter";
    default:
      return "";
  }
};

export const getClientDocType = (serviceType) => {
  switch (serviceType) {
    case "tds":
      return "TDS Client";
    case "income-tax":
      return "Income Tax Client";
    case "gstin":
      return "GST Client";
    default:
      return "";
  }
};

export const getClientsFields = (serviceType) => {
  switch (serviceType) {
    case "tds":
      return [
        "name",
        "client_name",
        "disabled",
        "tds_username",
        "last_tds_sync",
        "is_processing",
      ];
    case "income-tax":
      return [
        "name",
        "client_name",
        "disabled",
        "username",
        "last_income_tax_sync",
        "is_processing",
      ];
    case "gstin":
      return [
        "name",
        "client_name",
        "disabled",
        "gst_username",
        "last_gst_sync",
        "is_processing",
      ];
    default:
      return "";
  }
};

export function formatDateToDDMMYYYY(dateString) {
  if (!dateString) return "";

  const date = new Date(dateString);

  if (isNaN(date)) return ""; // invalid date fallback

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}
